import { Box, Text } from '@chakra-ui/react';
import styles from '@/pages/automation/jobs/cellRenderer/JobStatusCellRenderer.module.css';

const STATUS_CONFIG = {
    available: { type: 'active', label: 'Available' },
    verified: { type: 'active', label: 'Verified' },
    verify: { type: 'processing', label: 'Verify' },
    disabled: { type: 'disabled', label: 'Disabled' },
};

const SSOStatusCellRenderer = ({ status, onClick, isLoading }) => {
    const key = status?.toLowerCase();
    const config = STATUS_CONFIG[key] ?? {
        type: 'disabled',
        label: status ?? 'Unknown',
    };
    const isClickable = key === 'verify' && Boolean(onClick);

    return (
        <Box
            className={`${styles.tag} ${styles[config.type + 'Tag']}`}
            onClick={isClickable ? onClick : undefined}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: isClickable ? 'pointer' : 'default',
                opacity: isLoading ? 0.6 : 1,
                width: 'fit-content',
                minWidth: '80px',
            }}>
            <Text isTruncated>{isLoading ? 'Verifying…' : config.label}</Text>
        </Box>
    );
};

export default SSOStatusCellRenderer;
